import React from 'react';

export default function Page(props: { type: string; component: (props?: any) => JSX.Element }) {
	return <></>;
}
